import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import get from 'lodash/get';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';

import { t } from '../../../helpers/t';
import { Modal } from '../../../helpers/modal';

export function ListingDescription() {
  const { _meta, open_drafts } = useSelector((state) => state.listing, shallowEqual);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const draft = get(open_drafts, '[0].description');

  return (
    <div className="description px-4 md:px-0 py-6">
      <h2 id="space_description" className="text-stone-900 text-2xl font-semibold mb-4">
        {t('listings.show.sections.description.header')}
      </h2>
      {
        draft ? (
          <>
            <div className="listing-description" itemProp="description" data-ng-class="{'draft-original': viewingDraft}">
              {_meta.descriptionLines.map((line, index) => (
                <p key={`listing-description-line-${index}`} className="text-stone-900 font-extralight text-base">{line}</p>
              ))}
            </div>
            <div className="listing-description draft" data-ng-show="viewingDraft">
              {draft.split(/[\r\n]+/g).map((line, index) => (
                <p key={`listing-description-line-${index}`} className="text-stone-900 font-extralight text-base">{line}</p>
              ))}
            </div>
          </>
        )
        : (
          <>
            <div className="listing-description" itemProp="description">
              {_meta.shortenedDescriptionLines.map((line, index) => (
                <p key={`listing-description-line-${index}`} className="text-stone-900 font-extralight text-base">{line}</p>
              ))}
            </div>
            {_meta.showMoreDescriptionButton && (
              <>
                <button
                  onClick={() => setIsModalOpened(true)}
                  className="inline-flex items-center py-3 px-4 bg-stone-100 hover:bg-stone-200 rounded-lg transition-all duration-200 text-stone-700 hover:text-stone-900 font-medium mt-4"
                  style={{ border: '1px solid #d6d3d1', borderRadius: '8px' }}
                >
                  <span>{t('listings.show.sections.description.showMore')}</span>
                  <FontAwesomeIcon icon={faAngleRight} className="ml-2" aria-hidden />
                </button>
                <Modal
                  id="listing-description-modal"
                  isOpen={isModalOpened}
                  onClose={() => setIsModalOpened(false)}
                  header={(
                    <h2 id="space_description" className="text-stone-900 text-xl font-medium m-0">
                      {t('listings.show.sections.description.header')}
                    </h2>
                  )}
                >
                  <div className="p-4">
                    {_meta.descriptionLines.map((line, index) => (
                      <p
                        key={`listing-modal-description-line-${index}`}
                        className={classNames('text-stone-900 font-extralight text-base', (index === 0 || index === _meta.descriptionLines.length - 1) && 'my-0')}>
                        {line}
                      </p>
                    ))}
                  </div>
                </Modal>
              </>
            )}
          </>
        )
      }
    </div>
  );
}
